import React from 'react';
import PropTypes from 'prop-types';
import {
  CarouselProvider, Slider, Slide, DotGroup,
} from 'pure-react-carousel';
import cx from 'classnames';

import 'pure-react-carousel/dist/react-carousel.es.css';
import './ImageCarousel.scss';

const ImageCarousel = (props) => {
  const { slides, isMobile, isPlaying } = props;

  if (!slides.length) return null;

  return (
    <div
      className={cx('ImageCarousel', {
        'ImageCarousel--mobile': isMobile,
        'ImageCarousel--static': slides.length === 1,
      })}
      aria-hidden="true"
    >
      <CarouselProvider
        isPlaying={isPlaying}
        touchEnabled
        naturalSlideHeight={360}
        naturalSlideWidth={640}
        totalSlides={slides.length}
        interval={3000}
      >
        <Slider tabIndex={-1}>
          {slides.map((slide, index) => (
            <Slide index={index} tabIndex={-1}>
              <div
                className="ImageCarousel__slide"
                style={{ backgroundImage: `url(${slide.url})` }}
                key={slide.id}
                tabIndex={-1}
              />
            </Slide>
          ))}
        </Slider>
        <DotGroup />
      </CarouselProvider>
    </div>
  );
};

ImageCarousel.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
  })),
  isMobile: PropTypes.bool,
  isPlaying: PropTypes.bool,
};

ImageCarousel.defaultProps = {
  slides: [],
  isMobile: false,
  isPlaying: false,
};

ImageCarousel.displayName = 'ImageCarousel';
export default ImageCarousel;
